// import { DataTableComponent } from './data-table/data-table.component';
import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { APP_INITIALIZER, NgModule } from "@angular/core";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatBottomSheet } from "@angular/material/bottom-sheet";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatMenuModule } from "@angular/material/menu";
import { MatSnackBar } from "@angular/material/snack-bar";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { RouterModule, Routes } from "@angular/router";
import {
  FuseProgressBarModule,
  FuseSidebarModule,
  FuseThemeOptionsModule,
} from "@fuse/components";
import { FuseModule } from "@fuse/fuse.module";
import { FuseSharedModule } from "@fuse/shared.module";
import { TranslateModule } from "@ngx-translate/core";
import { AppComponent } from "app/app.component";
import { fuseConfig } from "app/fuse-config";
import { LayoutModule } from "app/layout/layout.module";
import { AlertsWelcomeModule } from "app/main/alerts-welcome/alerts-welcome.module";
import { BasicMemberDetailsDialogComponent } from "./helper-components/basic-member-details-dialog/basic-member-details-dialog.component";
import { BoothCardComponent } from "./helper-components/booth-card/booth-card.component";
import { SimpleCardComponent } from "./helper-components/simple-card/simple-card.component";
import { LoginDataProviderService } from "./helpers/login-data-provider.service";
import { UserDataService } from "./helpers/user-data.service";
import { HttpConfigInterceptor } from "./intreceptor/httpconfig.interceptor";
import { ChiefBarrackExecutiveModule } from "./main/chief-barrack-executive/chief-barrack-executive.module";
import { ConstituencyBoothModule } from "./main/constituency-booth/constituency-booth.module";
import { DevelopmentModule } from "./main/development/development.module";
import { ElectionListModule } from "./main/election-list/election-list.module";
import { SingleventModule } from "./main/singlevent/singlevent.module";
import { VerifyPostModule } from "./main/verify-post/verify-post.component.module";
import { VerifyReceiptModule } from "./main/verify-receipt/verify-receipt.component.module";

// import { DonationLoginComponent } from './donation-login/donation-login.component';
// import { DonationTableModule } from "app/donation-table/donation-table.module";

export function loginDataProviderFactory(provider: LoginDataProviderService) {
  return () => provider.load();
}

const appRoutes: Routes = [
  {
    path: "donation",
    loadChildren: () =>
      import("./donation-table /donation-table.module").then(
        (m) => m.DonationTableModule
      ),
  },
  {
    path: "auth",
    loadChildren: () => import("./main/auth.module").then((m) => m.AuthModule),
  },
  {
    path: "user",
    loadChildren: () => import("./main/user.module").then((m) => m.UserModule),
  },
  {
    path: "post",
    loadChildren: () =>
      import("./main/posts.module").then((m) => m.PostsModule),
  },
  {
    path: "country",
    loadChildren: () =>
      import("./main/country.module").then((m) => m.CountryModule),
  },
  {
    path: "loksabha",
    loadChildren: () =>
      import("./main/loksabha.module").then((m) => m.LoksabhaModule),
  },
  {
    path: "constituency",
    loadChildren: () =>
      import("./main/constituency.module").then((m) => m.ConstituencyModule),
  },
  {
    path: "zone",
    loadChildren: () => import("./main/zone.module").then((m) => m.ZoneModule),
  },
  {
    path: "district",
    loadChildren: () =>
      import("./main/district.module").then((m) => m.DistrictModule),
  },
  {
    path: "barrack",
    loadChildren: () =>
      import("./main/barrack.module").then((m) => m.BarrackModule),
  },
  {
    path: "statistics",
    loadChildren: () =>
      import("./main/statistics.module").then((m) => m.StatisticsModule),
  },
  {
    path: "events",
    loadChildren: () =>
      import("./main/events.module").then((m) => m.EventModule),
  },
  {
    path: "appointments",
    loadChildren: () =>
      import("./main/appointments.module").then((m) => m.AppointmentsModule),
  },
  {
    path: "administration",
    loadChildren: () =>
      import("./main/administration.module").then(
        (m) => m.AdministrationModule
      ),
  },
  {
    path: "finance",
    loadChildren: () =>
      import("./main/finance.module").then((m) => m.FinanceModule),
  },
  {
    path: "election",
    loadChildren: () =>
      import("./main/election.module").then((m) => m.ElectionModule),
  },
  {
    path: "assembly",
    loadChildren: () =>
      import("./main/assembly.module").then((m) => m.AssemblyModule),
  },
  {
    path: "cons-circle",
    loadChildren: () =>
      import("./main/cons-circle.module").then((m) => m.ConsCircleModule),
  },
  {
    path: "panchayat",
    loadChildren: () =>
      import("./main/panchayat.module").then((m) => m.PanchayatsModule),
  },
  {
    path: "section",
    loadChildren: () =>
      import("./main/section.module").then((m) => m.SectionsModule),
  },
  {
    path: "ward",
    loadChildren: () => import("./main/ward.module").then((m) => m.WardsModule),
  },
  {
    path: "booth",
    loadChildren: () =>
      import("./main/booth.module").then((m) => m.BoothModule),
  },
  {
    path: "branch",
    loadChildren: () =>
      import("./main/branch.module").then((m) => m.BranchModule),
  },
  {
    path: "tamilnadu",
    loadChildren: () =>
      import("./main/tamilnadu.module").then((m) => m.TamilnaduModule),
  },
  {
    path: "other",
    loadChildren: () =>
      import("./main/other.module").then((m) => m.OtherModule),
  },
  {
    path: "donate",
    loadChildren: () =>
      import("./main/donate.module").then((m) => m.DonateModule),
  },
  {
    path: "ecommerce",
    loadChildren: () =>
      import("./main/e-commerce.module").then((m) => m.EcommerceModule),
  },
  {
    path: "donation",
    loadChildren: () =>
      import("./main/donation.module").then((m) => m.DonationModule),
  },
  {
    path: "survey",
    loadChildren: () =>
      import("./main/survey.module").then((m) => m.SurveyModule),
  },
  {
    path: "uploads",
    loadChildren: () =>
      import("./main/uploads.module").then((m) => m.UploadsModule),
  },
  {
    path: "blood-donation",
    loadChildren: () =>
      import("./main/blood-donation/blood-donation.module").then(
        (m) => m.BloodDonationModule
      ),
  },
  {
    path: "construct",
    loadChildren: () =>
      import("./main/construct-sections/construct-sections.module").then(
        (m) => m.ConstructSectionListModule
      ),
  },
  {
    path: "**",
    redirectTo: "auth/login",
  },
];

@NgModule({
  declarations: [
    AppComponent,
    SimpleCardComponent,
    BasicMemberDetailsDialogComponent,
    BoothCardComponent,
  ],
  providers: [
    LoginDataProviderService,
    UserDataService,
    MatSnackBar,
    MatBottomSheet,
    {
      provide: APP_INITIALIZER,
      useFactory: loginDataProviderFactory,
      deps: [LoginDataProviderService],
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpConfigInterceptor,
      multi: true,
    },
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    RouterModule.forRoot(appRoutes),

    TranslateModule.forRoot(),

    // Material
    MatButtonModule,
    MatIconModule,
    MatAutocompleteModule,

    // Fuse modules
    FuseModule.forRoot(fuseConfig),
    FuseProgressBarModule,
    FuseSharedModule,
    FuseSidebarModule,
    FuseThemeOptionsModule,
    // App modules
    LayoutModule,
    DevelopmentModule,
    AlertsWelcomeModule,
    ConstituencyBoothModule,
    SingleventModule,
    ChiefBarrackExecutiveModule,
    VerifyReceiptModule,
    VerifyPostModule,
    ElectionListModule,
    MatMenuModule,
    // DataTableModule
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor() {}
}
